<template>
    <div>
        <div
            v-if="
                canInsertObject &&
                !allowActive &&
                !showEdit &&
                !showObjectButtons
            "
        >
            <button
                @click="showEdit = true"
                class="button is-primary is-active is-size-5 lb-th-add-button"
            >
                +
            </button>
        </div>
        <div
            v-if="
                canInsertObject &&
                (showEdit || showObjectButtons) &&
                !allowActive
            "
            v-on-clickaway.self="onClickOutside"
        >
            <div v-for="option in availableObjects" :key="option">
                <button
                    class="button is-primary is-active is-1 lb-th-action-button"
                    @click.stop="$emit('add', { type: option })"
                >
                    + {{ $t(`App.${option}`) }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import { mixin as clickaway } from '@/directives/vue-clickaway';
export default {
    directives: {
        clickOutside: vClickOutside.directive,
    },
    mixins: [clickaway],
    props: {
        allowActive: {
            type: Boolean,
            default: false,
        },
        trigger: {
            type: Object,
            default: () => {
                return {};
            },
        },
        triggers: {
            type: Array,
            default: () => {
                return [];
            },
        },
        availableObjects: {
            type: Array,
            default: () => {
                return [];
            },
        },
        showObjectButtons: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isActive: false,
            showEdit: false,
        };
    },
    computed: {
        canInsertObject() {
            if (this.trigger.type == 'END') {
                return false;
            }
            return !this.allowActive && this.availableObjects.length;
        },
    },
    methods: {
        updateTrigger(trigger) {
            this.$emit('update:trigger', { type: trigger });
        },
        onClickOutside(e) {
            if (this.showEdit) {
                this.showEdit = false;
            }
        },
    },
    mounted() {
        // console.log(this.showObjectButtons)
    },
};
</script>

<style scoped>
.toolbar {
    position: absolute;
    top: -10px;
    right: 10px;
    z-index: 2;
}
.lb-th-add-button {
    padding: 0;
    height: 2rem;
    width: 2rem;
}
.lb-th-action-button {
    margin: 0.2rem;
    width: 12rem;
}
</style>
